/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authPatchOnboarding } from '../../axios/authPatchOnboarding'
import type {
	AuthPatchOnboardingError,
	AuthPatchOnboardingRequest,
	AuthPatchOnboardingResponse,
} from '../../types/AuthPatchOnboarding'

export const authPatchOnboardingMutationKey = () => [{ url: '/auth/me/onboarding' }] as const

export type AuthPatchOnboardingMutationKey = ReturnType<typeof authPatchOnboardingMutationKey>

export type AuthPatchOnboardingVariables = {
	data: AuthPatchOnboardingRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::patchOnboarding */
export function useAuthPatchOnboarding<TContext = unknown>(
	options?: UseMutationOptions<
		AuthPatchOnboardingResponse,
		AxiosError<AuthPatchOnboardingError>,
		AuthPatchOnboardingVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authPatchOnboardingMutationKey(),
		mutationFn: ({ data }: AuthPatchOnboardingVariables) => authPatchOnboarding(data, config).then(res => res.data),
		...options,
	})
}
